export default __webpack_public_path__ + "static/media/arboleda_logo.0fc9936f.png";